import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StakeAPI } from "../../../api/stakeApi";

const initialState = {
  status: false,
  data: {},
  currentRequestId: undefined,
  error: null,
  action: "",
  loading: "idle",
};

export const getUserStakes = createAsyncThunk(
  "staking/getUserStakes",
  async (stakeBody, { getState, rejectWithValue, requestId }) => {
    try {
      const { loading, currentRequestId } = await getState().staking;
      if (loading !== "pending" || currentRequestId !== requestId) return; // ensure redux is ready before making the api call.
      const data = await StakeAPI.userStakeDetails();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const stake = createAsyncThunk(
  "staking/stake",
  async (stakeBody, { getState, rejectWithValue, requestId }) => {
    try {
      const { loading, currentRequestId } = await getState().staking;
      if (loading !== "pending" || currentRequestId !== requestId) return; // ensure redux is ready before making the api call.
      const data = await StakeAPI.stake(stakeBody);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const withdrawStake = createAsyncThunk(
  "staking/withdrawStake",
  async (payload, { getState, rejectWithValue, requestId }) => {
    try {
      const { loading, currentRequestId } = await getState().staking;
      if (loading !== "pending" || currentRequestId !== requestId) return; // ensure redux is ready before making the api call.
      const data = await StakeAPI.withdrawStake(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
const stakingSlice = createSlice({
  name: "staking",
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(stake.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "stake";
        }
      })
      .addCase(stake.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, stake_pulsars: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(stake.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getUserStakes.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "user_stakes";
        }
      })
      .addCase(getUserStakes.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = { ...state.data, user_stake_details: action.payload };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(getUserStakes.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(withdrawStake.pending, (state, action) => {
        if (state.loading === "idle") {
          state.loading = "pending";
          state.currentRequestId = action.meta.requestId;
          state.error = null;
          state.action = "withdraw_stakes";
        }
      })
      .addCase(withdrawStake.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.data = {
            ...state.data,
            withdraw_stake_pulsars: action.payload,
          };
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(withdrawStake.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (
          state.loading === "pending" &&
          state.currentRequestId === requestId
        ) {
          state.loading = "idle";
          state.error =
            action.payload?.message ||
            action.error?.message ||
            "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  },
});

export default stakingSlice.reducer;
